import { mapState } from 'vuex';
import index from '@/modules/fahrdienst452/index';
import configMixin from '@/mixins/configMixin';

const fahrdienst452Mixin = {
  mixins: [configMixin],
  computed: {
    ...mapState('fahrdienst452', ['isLoaded', 'fahrdienst452FileById']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    useUmlaufLinieKursSelektion() {
      return !!this.moduleConfig.useUmlaufLinieKursSelektion;
    },
    useLinieKursSelektion() {
      return !this.moduleConfig.useUmlaufLinieKursSelektion && (this.moduleConfig.linieKursSelektion || !this.moduleConfig.linieKursSelektion);
    },
    moduleType: () => index.moduleType,
    moduleBackendId: () => index.api,
    route() {
      return this.$route.name;
    },
    track() {
      return this.$route.params.track;
    },
    line() {
      return this.$route.params.line;
    },
    tourHash() {
      return this.$route.params.tourHash;
    },
    documentId() {
      return this.$route.params.documentId;
    },
    dateYYYYMMDD() {
      return this.$route.params.dateYYYYMMDD || null;
    },
    routeName() {
      return this.$route.name;
    },
    routeHasTour() {
      return this.line && this.track;
    },
    routeHasHash() {
      return this.tourHash;
    },
    routeHasDate() {
      return this.dateYYYYMMDD;
    },
    routeHasDocument() {
      return this.documentId;
    },
    isRouteWithTourAndDoc() {
      return this.isTourRoute && this.isDocumentRoute && this.routeHasTour;
    },
    isRouteWithHashAndDoc() {
      return this.isHashRoute && this.isDocumentRoute && this.routeHasHash;
    },
    isBaseRoute() {
      return this.routeName === 'fahrdienst452';
    },
    isTourRoute() {
      return this.routeName.startsWith('fahrdienst452Tour');
    },
    isHashRoute() {
      return this.routeName.startsWith('fahrdienst452Hash');
    },
    isDocumentRoute() {
      return this.routeName.includes('File');
    },
    /**
     * Returns true if the route is one with an exclusive display of a tour (no document) or a combined route with a selected doc and
     * a selected tour AND an additional route query parameter "display=tour"
     * @returns {boolean}
     */
    isTourDisplayed() {
      //return (this.isDocumentRoute && !this.displayHint) || (this.isDocumentRoute && this.displayHint === 'doc');
      if (this.isTourRoute) return true;
      return this.isRouteWithTourAndDoc && this.displayHint === 'tour';
    },
    /**
     * Returns true if the route is one with an exclusive display of a document or a combined route with a selected doc and
     * a selected tour AND an additional route query parameter "display=doc"
     * @returns {boolean}
     */
    isDocumentDisplayed() {
      return this.isDocumentRoute && (!this.displayHint || this.displayHint === 'doc');
    },
    isTourSwitchVisible() {
      return this.displayedDocument && this.dateYYYYMMDD && (this.isRouteWithTourAndDoc || this.isRouteWithHashAndDoc) && this.isDocumentDisplayed;
    },
    isDocumentSwitchVisible() {
      return (this.isRouteWithTourAndDoc || this.isRouteWithHashAndDoc) && this.routeHasDate && !this.isDocumentDisplayed;
    },
    isFollowTimeVisible() {
      return this.dateYYYYMMDD && (this.routeHasTour || this.routeHasHash) && (!this.displayHint || this.displayHint === 'tour');
    },
    documentExists() {
      if (this.isLoaded && this.documentId) {
        if (this.fahrdienst452FileById[this.$route.params.documentId]) {
          return true;
        }
      }
      return null;
    },
    displayHint() {
      return this.$route.query.display;
    },
    displayedDocument() {
      if (this.isLoaded && this.$route.params.documentId) {
        return this.fahrdienst452FileById[this.$route.params.documentId];
      }
      return null;
    },
    displayedDocumentUrl() {
      return this.displayedDocument ? this.constructPdfJsFileUrl(this.moduleBackendId, this.displayedDocument, 'filename') : null;
    },
  },
};
export default fahrdienst452Mixin;
